import { ComponentUtil } from 'ag-grid-community';
import { AgGridVue } from 'ag-grid-vue3';

/**
 * Global patch for ag-grid-vue3 upstream multi-grid prop reactivity bug:
 * In ag-grid-vue3 v31, getAgGridProperties() registers watchers that close over
 * a module-level `changes = {}` and `timeout = null` closure variable.
 * When multiple <AgGridVue> instances coexist on a page and receive prop updates
 * within the same tick, `changes` is overwritten by subsequent grid instances,
 * causing earlier grids to receive and render data belonging to other grids.
 *
 * This patch replaces the handlers in AgGridVue.watch to use per-instance
 * properties (`this._agChanges` and `this._agTimeout`), guaranteeing 100% data
 * isolation between multiple grid instances on the same page.
 */
if (AgGridVue && AgGridVue.watch) {
  Object.keys(AgGridVue.watch).forEach((prop) => {
    if (prop === 'modelValue') return;
    AgGridVue.watch[prop] = {
      handler(currentValue) {
        if (!this._agChanges) this._agChanges = {};
        this._agChanges[prop] = currentValue === ComponentUtil.VUE_OMITTED_PROPERTY ? void 0 : currentValue;
        if (this._agTimeout == null) {
          this._agTimeout = setTimeout(() => {
            if (this.api && !this.isDestroyed) {
              ComponentUtil.processOnChange(this._agChanges, this.api, true);
            }
            this._agTimeout = null;
            this._agChanges = {};
          }, 0);
        }
      },
      deep: true
    };
  });
}
